import React from 'react';
import styles from '../../Payments.module.css';

const HowItWorks = () => (
  <section className={styles.sec} id="how">
    <div className={styles.container}>
      <div className={`${styles.secHead} ${styles.secHeadCenter} ${styles.sr}`} data-sr>
        <span className={styles.eyebrow}><span className={styles.dot} />How it works</span>
        <h2>Accept a payment in three steps.</h2>
        <p className={styles.secLead}>Send a request or add Fyntiq to your checkout, let the customer choose, and get paid.</p>
      </div>
      <div className={styles.steps}>
        <div className={`${styles.step} ${styles.sr}`} data-sr>
          <div className={styles.stepN}>01</div>
          <div className={styles.stepIc}>
            <svg viewBox="0 0 24 24" fill="none" stroke="#FF5A36" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
              <path d="M10 13a5 5 0 0 0 7 0l2-2a5 5 0 0 0-7-7l-1 1" /><path d="M14 11a5 5 0 0 0-7 0l-2 2a5 5 0 0 0 7 7l1-1" />
            </svg>
          </div>
          <h3>Create a link or add checkout</h3>
          <p>Generate a payment link, attach one to an invoice, or drop Fyntiq into your existing checkout.</p>
        </div>
        <div className={`${styles.step} ${styles.sr}`} data-sr>
          <div className={styles.stepN}>02</div>
          <div className={styles.stepIc}>
            <svg viewBox="0 0 24 24" fill="none" stroke="#FF5A36" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
              <rect x="3" y="6" width="18" height="13" rx="2" /><path d="M3 10h18M7 15h4" />
            </svg>
          </div>
          <h3>Customer pays their way</h3>
          <p>Wallet, card, Apple Pay, Google Pay, Cash App Pay, bank transfer, or financing — their choice.</p>
        </div>
        <div className={`${styles.step} ${styles.sr}`} data-sr>
          <div className={styles.stepN}>03</div>
          <div className={styles.stepIc}>
            <svg viewBox="0 0 24 24" fill="none" stroke="#FF5A36" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
              <path d="M12 3v12m0 0-4-4m4 4 4-4M5 21h14" />
            </svg>
          </div>
          <h3>Get paid</h3>
          <p>Same day with Fyntiq Wallet, and about two business days for cards and bank transfers.</p>
        </div>
      </div>
    </div>
  </section>
);

export default HowItWorks;
